const BUTTON_TYPES = {
	PRIMARY: 'PRIMARY',
	SECONDARY: 'SECONDARY',
	TETIARY: 'TETIARY',
};

export default BUTTON_TYPES;
